module.exports = __webpack_public_path__ + "static/media/area_damage_image.4026908f.png";